import { useEffect, useState } from "react";

import CardsDeckCustom from "../../utils/CardsDeckCustom";

import AlertMessage from "../../utils/AlertMessage";

import PropTypes from "prop-types";

import { connect, useDispatch } from "react-redux";

import { bindActionCreators } from "redux";

import {
  tilesRestartMessages,
  addTile,
  addDocument,
  tilesAreLoaded,
  tileTypeListIsLoaded,
  // tilesAreCleared,
  // updateDataArr,
  // getTilesAdditional,
} from "../../actions/tileActions";

import { useTranslation } from "react-i18next";

import CustomModal from "../../utils/CustomModal";

import Row from "react-bootstrap/Row";

import Col from "react-bootstrap/Col";

import { WORKSPACE_TYPE_PRIVATE } from "../../constants/stringConstants";

import FieldsInForm from "../../utils/FieldsInForm";
import Loader from "../../utils/Loader";
import { isIPad13 } from "react-device-detect";

const DocumentAssessmentContainer = ({
  dataTiles,
  // tiles,
  loggedIn,
  userToken,
  currentWorkspace,
  user,
  tilesRestartMessages,
  tileTypes,
  addTile,
  tilesAreLoading,
  tileTypesAreLoading,
  id,
  fromDocumentContainer,
  addDocument,
  singleDocument,
  singleTopic,
  userRights,
  // topic_document_id,
}) => {
  const [failureMessage, setFailureMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [createNewTileIsShown, setCreateNewTileIsShown] = useState(false);
  const [submitCreationOccurred, setSubmitCreationOccurred] = useState(false);
  const [tile_audience, setTileAudience] = useState("private");
  const [tile_type, setTileType] = useState("1");
  const { t } = useTranslation();

  // const [savedTiles, setSavedTiles] = useState(dataTiles ? dataTiles : []);
  const dispatch = useDispatch();

  // let data = localStorage.getItem("dataTiles");

  // useEffect(() => {
  //   if (data) {
  //     let getTilesFromStorage = JSON.parse(data);
  //     setSavedTiles(getTilesFromStorage);
  //   }
  // }, [data]);

  const [storedTileTypes, setStoredTileTypes] = useState(tileTypes);
  const [storedSingleTopic, setSingleTopic] = useState("");

  useEffect(() => {
    if (!tileTypes.length) {
      const data = localStorage.getItem("tileTypes");
      const parsedData = JSON.parse(data);
      if (parsedData) {
        setStoredTileTypes(parsedData);
        dispatch(tileTypeListIsLoaded(parsedData));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (singleTopic.TOPIC_ID === undefined) {
      let getSingleTopic = localStorage.getItem("singleTopicId");
      setSingleTopic(getSingleTopic);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (dataTiles?.length) {
  //     localStorage.setItem("dataTiles", JSON.stringify(dataTiles));
  //     console.log("dataTiles", dataTiles);
  //     dispatch(tilesAreLoaded(dataTiles));
  //   }
  // }, [dataTiles, dispatch]);

  // useEffect(() => {
  //   if (data) {
  //     let getTilesFromStorage = JSON.parse(data);
  //     setSavedTiles(getTilesFromStorage);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const argsForAddTileDialog = {
    findFirstFormErrors: (form) => {
      const { TILE_NAME } = form;
      const newErrors = {};

      if (!TILE_NAME || TILE_NAME === "")
        newErrors.TILE_NAME = t("tileNameIsMandatory");
      else if (TILE_NAME.length > 255)
        newErrors.TILE_NAME = t("tileNameCantBeLongerThan255Charachteres");

      return newErrors;
    },
    fieldsForFirstForm: [
      {
        name: "TILE_NAME",
        type: "text",
        className: "register-login-text-field",
        required: true,
        classnameofgroup: "register-login-text-field-group",
        label: t("nameTheTile"),
        placeholder: t("egIdentifiedRisks"),
      },
      {
        name: "TILE_AUDIENCE",
        type: "multi-radiobuttons",
        className: "register-login-text-field",
        required: false,
        classnameofgroup:
          currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE
            ? "register-login-text-field-group cursor-not-allowed"
            : "register-login-text-field-group cursor-pointer",
        data: [
          {
            description: t("privateTile"),
            value: "private",
            subdescription: t("visibleOnlyToYou"),
          },
          {
            description: t("publicTile"),
            value: "public",
            subdescription: t("visibleToEveryoneFromYourTeamMakeTilesPublic"),
          },
        ],
        displayProperty: "description",
        valueProperty: "value",
        subDisplayProperty: "subdescription",
        defaultChecked: WORKSPACE_TYPE_PRIVATE,
        classNameReactFormal: "register-login-react-formal",
        classNameForm: "register-login-react-form",
        disabled:
          currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE &&
          userRights.USER_RIGHT !== "partner",
        onRadioButtonChange: (value) => {
          setTileAudience(value);
        },
      },
    ],
    fieldsForSecondForm: [
      {
        name: "TILE_TYPE",
        type: "radiobuttons-cards",
        className: "tile-radio-button-card",
        classNameOfRadio: "tile-radio-button",
        required: true,
        data: storedTileTypes,
        label: t("selectAType"),
        onRadioButtonChange: (value) => {
          setTileType(value);
        },
        titleProperty: "TILE_TYPE_NAME",
        imageProperty: "TILE_TYPE_ICON_PATH",
        descriptionProperty: "TILE_TYPE_DESCRIPTION",
        valueProperty: "TILE_TYPE_ID",
        statusProperty: "TILE_TYPE_STATUS",
        classnameofgroup: "register-login-text-field-group",
        defaultChecked:
          tileTypes.length &&
          tileTypes.filter((o) => o?.TILE_TYPE_NAME === "Text")[0]
            ? tileTypes.filter((o) => o?.TILE_TYPE_NAME === "Text")[0]
                .TILE_TYPE_ID
            : 0,
      },
    ],
    onSubmit: (values) => {
      if (singleDocument.document_id === 0) {
        addDocument(
          userToken,
          singleTopic.TOPIC_ID !== undefined
            ? singleTopic.TOPIC_ID
            : storedSingleTopic,
          singleDocument.news_title,
          singleDocument.id,
          values.TILE_NAME,
          tileTypes?.filter((o) => o.TILE_TYPE_ID === tile_type)[0]
            .TILE_TYPE_NAME,
          tile_audience
        );
      } else {
        addTile(
          userToken,
          values.TILE_NAME,
          tileTypes.filter((o) => o.TILE_TYPE_ID === tile_type)[0]
            .TILE_TYPE_NAME,
          tile_audience,
          singleDocument.document_id
        );
      }

      setCreateNewTileIsShown(false);
      setTileType("1");
      setTileAudience("private");
    },
  };

  return (
    <div className="assessment-container">
      {tilesAreLoading || tileTypesAreLoading ? (
        <Loader />
      ) : (
        <>
          <CardsDeckCustom
            classNameOfCard="homepage-card apply-border-white-color"
            classNameOfCardsColumns={
              isIPad13
                ? "homepage-cards-for-iPad homepage-cards-columns"
                : "homepage-cards-columns"
            }
            cards={dataTiles}
            loggedIn={loggedIn}
            userEmail={user.USER_EMAIL}
            userToken={userToken}
            currentWorkspace={currentWorkspace}
            fromMyAssessment={true}
            setCreateNewTileIsShown={setCreateNewTileIsShown}
            id={id}
            fromDocumentContainer={fromDocumentContainer}
          />
          <CustomModal
            isShown={createNewTileIsShown}
            setIsShown={setCreateNewTileIsShown}
            negativeAction={() => {
              setTileType("1");
              setTileAudience("private");
              setCreateNewTileIsShown(false);
            }}
            isBackdrop="static"
            isCentered={true}
            classNameOfModal="reghub-modal reghub-modal-add-new-tile"
            formId="add-new-tile-form"
            positiveAction={() => setSubmitCreationOccurred(true)}
            negativeButton={t("cancel")}
            positiveButton={t("createTile")}
            titleOfModal={t("addATile")}
            content={
              <Row className="add-new-tile-row">
                <Col className="add-new-tile-first-col">
                  <FieldsInForm
                    idOfForm="add-new-tile-form"
                    fields={argsForAddTileDialog.fieldsForFirstForm}
                    onSubmit={argsForAddTileDialog?.onSubmit}
                    findFormErrors={argsForAddTileDialog.findFirstFormErrors}
                    setSubmitOccurred={setSubmitCreationOccurred}
                    submitOccurred={submitCreationOccurred}
                  />
                </Col>
                <Col className="add-new-tile-second-col">
                  <FieldsInForm
                    fields={argsForAddTileDialog.fieldsForSecondForm}
                  />
                </Col>
              </Row>
            }
          />
        </>
      )}
      {failureMessage ? (
        <AlertMessage
          variant="danger"
          onClose={() => {
            setFailureMessage("");
            tilesRestartMessages();
          }}
          successHeading={t("failure")}
          mainMessage={failureMessage}
        />
      ) : (
        <div className="display-none" />
      )}
      {successMessage ? (
        <AlertMessage
          variant="success"
          onClose={() => {
            setSuccessMessage("");
            tilesRestartMessages();
          }}
          successHeading={t("success")}
          mainMessage={successMessage}
        />
      ) : (
        <div className="display-none" />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    tiles: state.tileReducer.tilesAreLoaded,
    dataTiles: state.tileReducer.updatedTilesData,
    loggedIn: state.userReducer.loggedIn,
    userToken: state.configReducer.userToken,
    user: state.userReducer.user,
    currentWorkspace: state.configReducer.currentWorkspace,
    tileSuccessMessage: state.tileReducer.tileSuccessMessage,
    tileErrorMessage: state.tileReducer.tileErrorMessage,
    tileTypes: state.tileReducer.tileTypes,
    tilesAreLoading: state.tileReducer.tilesAreLoading,
    tileTypesAreLoading: state.tileReducer.tileTypesAreLoading,
    singleTopic: state.topicReducer.singleTopic,
    userRights: state.userReducer.userRights,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    tilesRestartMessages: bindActionCreators(tilesRestartMessages, dispatch),
    addTile: bindActionCreators(addTile, dispatch),
    addDocument: bindActionCreators(addDocument, dispatch),
    tiles: bindActionCreators(tilesAreLoaded, dispatch),
  };
};

DocumentAssessmentContainer.propTypes = {
  // tiles: PropTypes.arrayOf(PropTypes.shape({})),
  dataTiles: PropTypes.arrayOf(PropTypes.shape({})),
  loggedIn: PropTypes.bool.isRequired,
  userToken: PropTypes.string.isRequired,
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }).isRequired,
  user: PropTypes.shape({
    USER_EMAIL: PropTypes.string,
  }).isRequired,

  tilesRestartMessages: PropTypes.func.isRequired,
  tileTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  addTile: PropTypes.func.isRequired,
  tilesAreLoading: PropTypes.bool.isRequired,
  tileTypesAreLoading: PropTypes.bool.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
  ]),
  fromDocumentContainer: PropTypes.bool.isRequired,
  addDocument: PropTypes.func.isRequired,
  singleDocument: PropTypes.shape({
    document_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    news_title: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  singleTopic: PropTypes.shape({
    TOPIC_ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  userRights: PropTypes.shape({ USER_RIGHT: PropTypes.string }).isRequired,
  // topic_document_id: PropTypes.string.isRequired,
};

DocumentAssessmentContainer.defaultProps = {
  tiles: [],
  loggedIn: false,
  userToken: "",
  currentWorkspace: {
    WORKSPACE_TYPE: "",
  },
  user: {},
  tileSuccessMessage: "",
  tileErrorMessage: "",
  tilesRestartMessages: () => {},
  tileTypes: {},
  addTile: () => {},
  tilesAreLoading: false,
  tileTypesAreLoading: false,
  id: "",
  fromDocumentContainer: false,
  addDocument: () => {},
  singleDocument: {},
  singleTopic: {},
  userRights: { USER_RIGHT: "" },
  topic_document_id: "",
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentAssessmentContainer);
